export const translationEngDefault = {
    SkhemataFaqSearch: {
        "searchPlaceholder": "Enter Search Keyword...",
    }
};
//# sourceMappingURL=eng.js.map